module.exports = __webpack_public_path__ + "img/do-challenge.9938b99f.png";